import _, { isEmpty } from 'lodash';
import React from 'react';
import InvoiceLineItem from '../../../Entities/InvoiceLineItem';
import LineItemEntry from '../../../Entities/LineItemEntry';
import InvoiceTotalSummaryTableRow from './InvoiceTotalSummaryTableRow';
import getTotalAmount from '../../../Utils/invoicePanel'

import '../../Fields/InvoiceLineItemEntryTable.scss';
import './InvoiceTotalSummaryTable.scss';

const InvoiceTotalSummaryTable = ({lineItemTableRows, balance, currentBalance, adjustmentType, onLineItemChange, editMode}) =>  {

  const handleLineItemChange = (inputId, value) => {
    const lineItems = [];
    const totalAmounts = getTotalAmount(lineItemTableRows, balance);
    for (let i = 0; i < lineItemTableRows.length; i++) {
      const lineItem = _.cloneDeep(lineItemTableRows[i].data);
      if (lineItem.fields.balance.value > 0) {
        const originalAmount = getTotalAmount([lineItemTableRows[i]], balance, true);
        const totalPercentage = Number.isFinite(value / balance)
          ? value / balance
          : 0;
        const percentage = Math.floor(totalPercentage * 100);
        const amount = Math.floor(originalAmount[inputId] * (percentage / 100));
        const lineItemEntry = lineItem.fields.entries.value.find(
          (entry) => entry.fields.created_at.value === null
        );
        lineItemEntry.fields.type.value = adjustmentType;
        if (value < totalAmounts[inputId].value) {
          lineItemEntry.fields[inputId].value = amount;
        }
        lineItem.fields.entries.value[
          lineItem.fields.entries.value.length - 1
        ] = lineItemEntry;
      }
      lineItems.push(lineItem);
    }

    if (value > totalAmounts[inputId].value) {
      for (let i = 0; i < lineItems.length; i++) {
        lineItems[i].fields.entries.value[
          lineItems[i].fields.entries.value.length - 1
        ].fields[inputId].value = 0;
      }
      lineItems[0].fields.entries.value[
        lineItems[0].fields.entries.value.length - 1
      ].fields[inputId].value = value;
    } else {
      lineItems[0].fields.entries.value[
        lineItems[0].fields.entries.value.length - 1
      ].fields[inputId].value = 0;
      const remaining = getAdjustedRowAmounts(
        lineItems.map((item) => {
          return { data: item };
        })
      );
      let remain = value - remaining[inputId].value;
      while (remain > 0) {
        for (let i = 0; i < lineItems.length; i += 1) {
          const paymentEntry = lineItems[i].fields.entries.value.find(
            (entry) => entry.fields.created_at.value === null
          );
          const lineItemAmounts =
            lineItems[i].fields.adjusted_gross_amounts.value;
          if (lineItemAmounts[inputId] > 0) {
            if (paymentEntry.fields[inputId].value < lineItemAmounts[inputId]) {
              paymentEntry.fields[inputId].value++;
              if (--remain === 0) break;
            } else {
              if (
                paymentEntry.fields[inputId].value < lineItemAmounts[inputId]
              ) {
                paymentEntry.fields[inputId].value++;
                if (--remain === 0) break;
              }
            }
          }
        }
      }
    }

    onLineItemChange(lineItems);
  };

  const getAdjustedAmounts = (rows) => {
    const amounts = getTotalAmount(lineItemTableRows, balance);
    rows.forEach((row) => {
      row.data.fields.entries.value.forEach((entry) => {
        if(entry.fields.created_at.value === null) {
          amounts.amount.value = (amounts.amount.value || 0) - entry.fields.amount.value || 0;
          amounts.amount_tax_1.value = (amounts.amount_tax_1.value || 0) - entry.fields.amount_tax_1.value || 0;
          amounts.amount_tax_2.value = (amounts.amount_tax_2.value || 0) - entry.fields.amount_tax_2.value || 0;
          amounts.amount_tax_3.value = (amounts.amount_tax_3.value || 0) - entry.fields.amount_tax_3.value || 0;
          amounts.amount_tax_4.value = (amounts.amount_tax_4.value || 0) - entry.fields.amount_tax_4.value || 0;
          amounts.gross_amount.value = currentBalance
        }
      });
    });
    return amounts
  };

  const getAdjustedRowAmounts = (rows) => {
    const amounts = {amount: {}, amount_tax_1: {}, amount_tax_2: {}, amount_tax_3: {}, amount_tax_4: {}, gross_amount: {}};
    rows.forEach((row) => {
      row.data.fields.entries.value.forEach((entry) => {
        if(entry.fields.created_at.value === null) {
          amounts.amount['value'] = (amounts.amount?.value || 0) + entry.fields.amount.value || 0;
          amounts.amount_tax_1['value'] = (amounts.amount_tax_1?.value || 0) + entry.fields.amount_tax_1.value || 0;
          amounts.amount_tax_2['value'] = (amounts.amount_tax_2?.value || 0) + entry.fields.amount_tax_2.value || 0;
          amounts.amount_tax_3['value'] = (amounts.amount_tax_3?.value || 0) + entry.fields.amount_tax_3.value || 0;
          amounts.amount_tax_4['value'] = (amounts.amount_tax_4?.value || 0) + entry.fields.amount_tax_4.value || 0;
          amounts.gross_amount['value'] = (amounts.gross_amount?.value || 0) + amounts.gross_amount.value || 0;
        }
      });
    });
    return amounts
  };

    let rows = lineItemTableRows.filter((lineItemEntryRow) =>
      lineItemEntryRow.data.fields.entries.value.find(
        (entry) => entry.fields.created_at.value === null
      )
    );
    rows = isEmpty(rows)
      ? [
          {
            ident: 0,
            data: {
              fields: {
                ...new InvoiceLineItem(),
                entries: { value: [new LineItemEntry()] },
              },
            },
          },
        ]
      : rows;

    const totalAmount = getTotalAmount(lineItemTableRows, balance);
    const totalRow = {
      fields: {
        entries: { value: [new LineItemEntry()] },
      },
    };
    totalRow.fields.entries.value[0].fields = {
      ...totalRow.fields.entries.value[0].fields,
      ...totalAmount,
    };
    const adjustedAmounts = getAdjustedAmounts(rows);
    const adjustedBalanceRow = {
      fields: {
        entries: { value: [new LineItemEntry()] },
      },
    };
    adjustedBalanceRow.fields.entries.value[0].fields = {
      ...adjustedBalanceRow.fields.entries.value[0].fields,
      ...adjustedAmounts,
    };
    const adjustmentAmounts = getAdjustedRowAmounts(rows);
    const adjustmentRow = {
      fields: {
        entries: { value: [new LineItemEntry()] },
      },
    };
    adjustmentRow.fields.entries.value[0].fields = {
      ...adjustmentRow.fields.entries.value[0].fields,
      ...adjustmentAmounts,
    };

    const inputId = 'invoice-total-summary-table'

    return (
      <div className='parkchirp--invoice-total-summary-table'>
        <div>
          <header className='parkchirp--invoice-line-item-entry-table--header'>
            <div className='parkchirp--invoice-line-item-entry-table--row'>
              <div className='parkchirp--invoice-line-item-entry-table--type-column parkchirp--invoice-line-item-entry-table--cell'>
                <span className='parkchirp--invoice-line-item-entry-table--column-heading'></span>
              </div>
              <div className='parkchirp--invoice-line-item-entry-table--net-amount-column parkchirp--invoice-line-item-entry-table--cell'>
                <span className='parkchirp--invoice-line-item-entry-table--column-heading'>
                  Net Amount
                </span>
              </div>
              <div className='parkchirp--invoice-line-item-entry-table--amount-tax-1-column parkchirp--invoice-line-item-entry-table--cell'>
                <span className='parkchirp--invoice-line-item-entry-table--column-heading'>
                  Tax 1
                </span>
              </div>
              <div className='parkchirp--invoice-line-item-entry-table--amount-tax-2-column parkchirp--invoice-line-item-entry-table--cell'>
                <span className='parkchirp--invoice-line-item-entry-table--column-heading'>
                  Tax 2
                </span>
              </div>
              <div className='parkchirp--invoice-line-item-entry-table--amount-tax-3-column parkchirp--invoice-line-item-entry-table--cell'>
                <span className='parkchirp--invoice-line-item-entry-table--column-heading'>
                  Tax 3
                </span>
              </div>
              <div className='parkchirp--invoice-line-item-entry-table--amount-tax-4-column parkchirp--invoice-line-item-entry-table--cell'>
                <span className='parkchirp--invoice-line-item-entry-table--column-heading'>
                  Tax 4
                </span>
              </div>
              <div className='parkchirp--invoice-line-item-entry-table--gross-amount-column parkchirp--invoice-line-item-entry-table--cell'>
                <span className='parkchirp--invoice-line-item-entry-table--column-heading'>
                  Gross Amount
                </span>
              </div>
            </div>
          </header>
          <div className='parkchirp--invoice-total-summary-table--body'>
            <InvoiceTotalSummaryTableRow
              inputId={`${inputId}--${0}`}
              type={'Current Balance'}
              lineItemEntryRow={totalRow}
            />
            <InvoiceTotalSummaryTableRow
              inputId={`${inputId}--${1}`}
              type={'Adjustment'}
              lineItemEntryRow={adjustmentRow}
              negativeMode={true}
              editMode={editMode}
              handleLineItemChange={handleLineItemChange}
              totalRow={totalRow.fields.entries.value[0]}
            />
            <InvoiceTotalSummaryTableRow
              inputId={`${inputId}--${2}`}
              type={'Adjusted Balance'}
              lineItemEntryRow={adjustedBalanceRow}
            />
          </div>
        </div>
      </div>
    );
}

export default InvoiceTotalSummaryTable;
